import { SET_ACTIVE, SET_SEARCH_TERM, CLEAR_SEARCH_TERM, SET_SUGGESTIONS, SET_INPUT_TYPE, SET_SEARCH_RESULT, CLEAR_SEARCH, CLEAR_RESULTS, SET_CURRENTITEM, SET_CURRENT_SEARCH_ITEM, CLEAR_CURRENT_SEARCH_ITEM } from "../actions/result.action";

const initialState = {
    isOpen: false,
    active: "video",
    searchType: "auto",
    searchTerm: "",
    suggestions: [],
    searchResultWeb: [],
    searchResultVideo: [],
    searchResultPhoto: [],
    currentItem: {},
    currentSearchImage: null
};

export default function resultReducer(state = initialState, action: any) {
    console.log(action)
    if (action.type === SET_ACTIVE) {
        return {
            ...state,
            active: action.active
        }
    }
    if (action.type === SET_SEARCH_TERM) {
        return {
            ...state,
            searchTerm: state.searchTerm + " " + action.term
        }
    }
    if (action.type === CLEAR_SEARCH_TERM) {

        return {
            ...state,
            searchTerm: ""
        }
    }
    if (action.type === SET_SUGGESTIONS) {
        const result = action.suggestionsBody.suggestionGroups[0].searchSuggestions;
        return Object.assign({}, state, { suggestions: result });
    }
    if (action.type === SET_INPUT_TYPE) {
        return {
            ...state,
            searchType: action.inputtype
        }
    }
    if (action.type === SET_SEARCH_RESULT) {
        if (action.resultType === 'video') {
            const result = action.searchResult.value;
            return Object.assign({}, state, { searchResultVideo: result });
        }
        if (action.resultType === 'image') {
            const result = action.searchResult.value;
            return Object.assign({}, state, { searchResultPhoto: result });
        }
        if (action.resultType === '') {
            const result = action.searchResult.webPages.value;
            console.log(result)
            return Object.assign({}, state, { searchResultWeb: result });
        }
    }
    if (action.type === CLEAR_SEARCH) {
        return Object.assign({}, state, {
            searchResultWeb: [],
            searchResultPhoto: [],
            searchResultVideo: [],
            suggestions: [],
            searchType: '',
            searchTerm: '',
            active: 'video'
        });
    }
    if (action.type === CLEAR_RESULTS) {
        return Object.assign({}, state, {
            searchResultWeb: [],
            searchResultPhoto: [],
            searchResultVideo: []
        });
    }

    if (action.type === SET_CURRENTITEM) {
        console.log(action.currentItem)
        return Object.assign({}, state, {
            currentItem: action.currentItem
        });
    }
    if (action.type === SET_CURRENT_SEARCH_ITEM) {
        return {
            ...state,
            currentSearchImage: action.current
        }
    }
    if (action.type === CLEAR_CURRENT_SEARCH_ITEM) {
        return {
            ...state,
            currentSearchImage: null
        }
    }
    return state;
}  